module.exports = __webpack_public_path__ + "static/shapes1-0464013ffbb05972a763b9caac376736.png";